import {AbstractControl} from '@angular/forms';
import {onlyNumbers} from '@clients/shared/utilities';

export function validSsn(c: AbstractControl): {[key: string]: any} | null {
    const test = c.value && onlyNumbers(c.value).length === 4;

    return test ? null : {invalidLastFourOfSocial: c.value};
}
